import { gql } from '@apollo/client';
import { useState } from 'react';
import { usePaginatedQuery } from '../../../hooks';
import { dropNullProps } from '../../../utils';

export const LIST_NOTIFICATION_JOBS = gql`
  query listNotificationJobs(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $jobId: ID
    $distinctJobs: Boolean
  ) {
    listNotificationJobs: listNotifications(
      after: $after
      before: $before
      first: $first
      last: $last
      jobId: $jobId
      distinctJobs: $distinctJobs
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          id
          jobId
          templateGroup
          created
          policy {
            id
            name
          }
        }
      }
    }
  }
`;

export default function useListNotificationJobs({ pageSize = 10, initialFilters = {} }) {
  const [filters, setFilters] = useState({
    distinctJobs: true,
    ...initialFilters
  });

  const { data, loading, error, refetch, paginationProps, queryProps, loadFirstPage } = usePaginatedQuery(
    LIST_NOTIFICATION_JOBS,
    {
      variables: dropNullProps({ ...filters }),
      pathToPageInfo: 'listNotificationJobs',
      pageSize,
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    notificationJobs: data?.listNotificationJobs?.edges?.map(({ node }) => node),
    loading,
    error,
    refetch,
    paginationProps,
    queryProps,
    filters,
    changeFilters(filters) {
      setFilters(state => {
        let newState = { ...state, ...filters };
        loadFirstPage(newState);
        return newState;
      });
    }
  };
}
